import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#061b13] px-5 py-14 text-center" data-id="element-69">
      <div className="mx-auto max-w-4xl" data-id="element-70">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-emerald-300" data-id="element-71">
          PALLAVOLO PRONTA™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-72">
          Il sistema N.1 per allenatori di pallavolo in Italia.
        </p>
        <p className="mt-2 text-sm italic text-slate-300" data-id="element-73">
          Perché allenare non dovrebbe costarti ogni serata della settimana.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-emerald-300/20 py-6 text-sm font-semibold text-slate-300" data-id="element-74">
          <a className="flex items-center gap-2 hover:text-white" href="mailto:soporte.edulabs@gmail.com" data-id="element-75">
            <MailIcon className="h-4 w-4 text-emerald-300" data-id="element-76" />
            soporte.edulabs@gmail.com
          </a>
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-slate-500" data-id="element-77">
          © PALLAVOLO PRONTA™ 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}